import { useCallback, useMemo } from "react";
import { Button, Radio, Row, Upload, Input, Form, Modal, Select } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import getAPPS from "../../../../utils/getAppAndGroups";

const { TextArea } = Input;
const { Option } = Select;

export function Sistema({ updateFile, form }) {
  const listApp = useMemo(() => getAPPS(), []);

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const beforeUpload = useCallback(
    (file, name) => {
      getBase64(file, (imageUrl) => updateFile({ [name]: imageUrl }));
      return false;
    },
    [updateFile]
  );

  const props = {
    accept: "image/png, image/jpeg, application/pdf",
    maxCount: 1,
    multiple: false,
  };

  // const info = useCallback((texto, nivelAcesso) => {
  //   Modal.info({
  //     title: nivelAcesso,
  //     content: <div>{texto}</div>,
  //     onOk() {},
  //   });
  // }, []);

  return (
    <>
      <Row justify="center" align="middle">
        <div className="ant-descriptions-title">Sistemas</div>
      </Row>

      <Form.Item
        name="sistema"
        rules={[{ required: true, message: "Por favor informe o sistema!" }]}
      >
        <Radio.Group>
          {listApp
            .filter((post) => post.app !== "PCA")
            .map((post) => {
              return (
                <Radio
                  onChange={() => form.setFieldsValue({ nivel: null })}
                  key={post.key}
                  value={post.app.replace(" ", "_")}
                >
                  {post.app}
                </Radio>
              );
            })}
        </Radio.Group>
      </Form.Item>

      {/* <Form.Item
        className="inputStyle"
        shouldUpdate={(old, current) =>
          old.sistema !== current.sistema || old.nivel !== current.nivel
        }
      >
        {({ getFieldValue }) => {
          if (getFieldValue("sistema")) {
            const nivelAcesso = getFieldValue("nivel");
            const sistemaSelecionado = listApp.filter(
              (v) => v.app === getFieldValue("sistema").replace("_", " ")
            )[0];
            const helps = sistemaSelecionado.groups.filter(
              (a) => a.name === nivelAcesso
            );

            return (
              <>
                <Form.Item
                  label="Nível de acesso"
                  name="nivel"
                  rules={[
                    {
                      required: true,
                      message: "Por favor informe o nível de acesso!",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Selecione o nível"
                    onChange={(value) => {
                      if (value) {
                        const helpsT = sistemaSelecionado.groups.filter(
                          (a) => a.name === value
                        );
                        if (helpsT && helpsT.length > 0)
                          info(helpsT[0].help, getFieldValue("nivel"));
                      }
                    }}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {sistemaSelecionado.groups.map((lista) => {
                      return (
                        <Option key={lista.key} value={lista.name}>
                          {lista.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                {helps && helps.length > 0 && (
                  <Tooltip title={helps[0].help}>
                    <Typography.Link
                      onClick={() => info(helps[0].help, nivelAcesso)}
                    >
                      Dúvida?
                    </Typography.Link>
                  </Tooltip>
                )}
              </>
            );
          }
          return <div />;
        }}
      </Form.Item> */}

      <Form.Item
        className="inputStyle"
        shouldUpdate={(old, current) =>
          old.sistema !== current.sistema || current.orgao === "OUTROS"
        }
      >
        {({ getFieldValue }) => {
          if (
            getFieldValue("sistema") === "AGILIS" ||
            getFieldValue("orgao") === "OUTROS"
          ) {
            const isVerificacao =
              getFieldValue("sistema") === "AGILIS" ||
              getFieldValue("orgao") !== "OUTROS";
            return (
              <>
                <div className="duasCollumn">
                  <Form.Item
                    className="inputStyle"
                    label="Mac da Máquina"
                    name="macMaquina"
                    rules={[
                      {
                        required:
                          getFieldValue("sistema") === "SIP3W" ||
                          getFieldValue("sistema") === "AGILIS",
                        message: "Por favor informe o Mac da Máquina!",
                      },
                      {
                        min: 12,
                        message: "Mac da Máquina mínimo 12 caracteres.",
                      },
                      {
                        max: 12,
                        message: "Mac da Máquina máximo 12 caracteres.",
                      },
                    ]}
                  >
                    <Input minLength={12} maxLength={12} />
                  </Form.Item>

                  <div className="sizeBoxWidth" />

                  {isVerificacao && (
                    <Form.Item
                      className="inputStyle"
                      span={10}
                      label="Nome da Máquina"
                      name="nomeMaquina"
                      rules={[
                        {
                          required: true,
                          message: "Por favor, informe o nome da Máquina!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  )}

                  <div className="sizeBoxWidth" />

                  {isVerificacao && (
                    <Form.Item
                      className="inputStyle"
                      span={10}
                      label="Número Serie HD "
                      name="numSerieHd"
                      rules={[
                        {
                          required: true,
                          message:
                            "Por favor, informe o número de serie do HD!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  )}
                </div>

                <div className="duasCollumn">
                  {isVerificacao && (
                    <>
                      <Form.Item
                        className="inputStyle"
                        label="IP da Máquina"
                        name="ipMaquina"
                        rules={[
                          {
                            required: true,
                            message: "Por favor informe o Ip da Máquina!",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                      <div className="sizeBoxWidth" />
                    </>
                  )}

                  <Form.Item
                    className="inputStyle"
                    label="Tombo da Máquina"
                    name="tomboMaquina"
                    rules={[
                      {
                        required:
                          getFieldValue("sistema") === "SIP3W" ||
                          getFieldValue("sistema") === "AGILIS",
                        message: "Por favor informe o Tombo da Máquina!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </div>
              </>
            );
          } else if (getFieldValue("sistema") === "ROTAS") {
            return (
              <div className="duasCollumn">
                <Form.Item
                  className="inputStyle"
                  name="ais"
                  label="AIS/GRUPO Especializado"
                  rules={[
                    {
                      required: true,
                      message: "Por favor, informe AIS/Grupo Especializado!",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Option value="">Selecione</Option>
                    <Option value="COPAC">COPAC</Option>
                    <Option value="BOPE">BOPE</Option>
                    <Option value="BPE">BPE</Option>
                    <Option value="BPGEP">BPGEP</Option>
                    <Option value="BPMA">BPMA</Option>
                    <Option value="BPRE">BPRE</Option>
                    <Option value="BPTUR">BPTUR</Option>
                    <Option value="CHOQUE">CHOQUE</Option>
                    <Option value="COD">COD</Option>
                    <Option value="COLOG">COLOG</Option>
                    <Option value="COTAM">COTAM</Option>
                    <Option value="COTAR">COTAR</Option>
                    <Option value="CPC">CPC3</Option>
                    <Option value="CPG">CPG</Option>
                    <Option value="GOE">GOE</Option>
                    <Option value="RAIO">RAIO</Option>
                    <Option value="AIS1">AIS1</Option>
                    <Option value="AIS2">AIS2</Option>
                    <Option value="AIS3">AIS3</Option>
                    <Option value="AIS4">AIS4</Option>
                    <Option value="AIS5">AIS5</Option>
                    <Option value="AIS6">AIS6</Option>
                    <Option value="AIS7">AIS7</Option>
                    <Option value="AIS8">AIS8</Option>
                    <Option value="AIS9">AIS9</Option>
                    <Option value="AIS10">AIS10</Option>
                    <Option value="AIS11">AIS11</Option>
                    <Option value="AIS12">AIS12</Option>
                    <Option value="AIS13">AIS13</Option>
                    <Option value="AIS14">AIS14</Option>
                    <Option value="AIS15">AIS15</Option>
                    <Option value="AIS16">AIS16</Option>
                    <Option value="AIS17">AIS17</Option>
                    <Option value="AIS18">AIS18</Option>
                    <Option value="AIS19">AIS19</Option>
                    <Option value="AIS20">AIS20</Option>
                    <Option value="AIS21">AIS21</Option>
                    <Option value="AIS22">AIS22</Option>
                    <Option value="AIS23">AIS23</Option>
                    <Option value="AIS24">AIS24</Option>
                    <Option value="AIS25">AIS25</Option>
                  </Select>
                </Form.Item>
              </div>
            );
          }

          return <div />;
        }}
      </Form.Item>

      <Form.Item
        label="Justificativa"
        name="justificativa"
        rules={[
          { required: true, message: "Por favor informe sua justificativa!" },
        ]}
      >
        <TextArea placeholder="Descreva sua justificativa" rows={2} />
      </Form.Item>
      <div className="duasCollumn">
        <div className="areaBtnAnexo">
          <Form.Item
            className="inputStyle"
            shouldUpdate={(old, current) =>
              old.isTercerizado !== current.isTercerizado
            }
          >
            {({ getFieldValue }) => {
              return (
                <Form.Item
                  label={
                    getFieldValue("isTercerizado")
                      ? "RG ou CNH (frente e verso)"
                      : "Identidade funcional (frente e verso)"
                  }
                  name="anexoIdentidadeFuncional"
                  rules={[
                    { required: true, message: "Por favor, informe o anexo!" },
                  ]}
                >
                  <Upload
                    onRemove={() =>
                      updateFile({ anexoAtestadoAntecedente: null })
                    }
                    {...props}
                    beforeUpload={(info) =>
                      beforeUpload(info, "anexoIdentidadeFuncional")
                    }
                  >
                    <Button className="btnAnexo" icon={<UploadOutlined />}>
                      Anexo
                    </Button>
                  </Upload>
                </Form.Item>
              );
            }}
          </Form.Item>
          {/* <Form.Item
            label="Atestado de Antecedentes Criminais da SSPDS"
            name="anexoAtestadoAntecedente"
            rules={[{ required: true, message: "Por favor, informe o anexo!" }]}
          >
            <Upload
              beforeUpload={(info) =>
                beforeUpload(info, "anexoAtestadoAntecedente")
              }
              onRemove={() => updateFile({ anexoAtestadoAntecedente: null })}
              {...props}
            >
              <Button className="btnAnexo" icon={<UploadOutlined />}>
                Anexo
              </Button>
            </Upload>
          </Form.Item> */}
        </div>
        <div className="areaBtnAnexo">
          <Form.Item
            className="inputStyle"
            shouldUpdate={(old, current) => old.orgao !== current.orgao}
          >
            {({ getFieldValue }) => {
              return (
                <>
                  <Form.Item
                    label={
                      getFieldValue("orgao") === "OUTROS"
                        ? "Ofício de Solicitação"
                        : "Certidão disciplinar CGD"
                    }
                    name="anexoCertidaoCGD"
                    rules={[
                      {
                        required: !getFieldValue("isTercerizado"),
                        message: "Por favor, informe o anexo!",
                      },
                    ]}
                  >
                    <Upload
                      onRemove={() =>
                        updateFile({ anexoAtestadoAntecedente: null })
                      }
                      beforeUpload={(info) =>
                        beforeUpload(info, "anexoCertidaoCGD")
                      }
                      {...props}
                    >
                      <Button className="btnAnexo" icon={<UploadOutlined />}>
                        Anexo
                      </Button>
                    </Upload>
                  </Form.Item>

                  <Form.Item
                    label="Termo de Cooperação/Convênio"
                    name="anexoTermoConvenio"
                    rules={[
                      {
                        required: getFieldValue("orgao") === "OUTROS",
                        message: "Por favor, informe o anexo!",
                      },
                    ]}
                  >
                    <Upload
                      onRemove={() => updateFile({ anexoTermoConvenio: null })}
                      beforeUpload={(info) =>
                        beforeUpload(info, "anexoTermoConvenio")
                      }
                      {...props}
                    >
                      <Button className="btnAnexo" icon={<UploadOutlined />}>
                        Anexo
                      </Button>
                    </Upload>
                  </Form.Item>
                  {/* <Form.Item
                 label={getFieldValue("orgao") === "OUTROS" ? "Ofício de Solicitação"  : "Certidão disciplinar CGD"}
                 name="anexoCertidaoCGD"
                 rules={[
                   {
                     required: !getFieldValue("isTercerizado"),
                     message: "Por favor, informe o anexo!",
                   },
                 ]}
               >
                 <Upload
                   onRemove={() =>
                     updateFile({ anexoAtestadoAntecedente: null })
                   }
                   beforeUpload={(info) =>
                     beforeUpload(info, "anexoCertidaoCGD")
                   }
                   {...props}
                 >
                   <Button className="btnAnexo" icon={<UploadOutlined />}>
                     Anexo
                   </Button>
                 </Upload>
               </Form.Item> */}
                </>
              );
            }}
          </Form.Item>

          {/* <Form.Item
            label="Certidão criminal do TJCE 1º instância"
            name="anexocertidaoForumTJCE"
            rules={[{ required: true, message: "Por favor, informe o anexo!" }]}
          >
            <Upload
              onRemove={() => updateFile({ anexoAtestadoAntecedente: null })}
              beforeUpload={(info) =>
                beforeUpload(info, "anexocertidaoForumTJCE")
              }
              {...props}
            >
              <Button className="btnAnexo" icon={<UploadOutlined />}>
                Anexo
              </Button>
            </Upload>
          </Form.Item> */}
        </div>
      </div>

      <div className="areaBtnAnexo"></div>
    </>
  );
}
